import useTranslation from '../../hooks/useTranslation'
import analyseImage from '../../../assets/image/intro/lupe.png'
import ComponentRenderer from './ComponentRenderer'

function AnalyseContent() {
  const t = useTranslation()
  const intro = t.landing.intro.analyse
  return (
    <ComponentRenderer
      headline={intro.headline}
      subline={intro.body}
      ctaLabel={intro.ctaLabel}
      ctaHref={intro.ctaHref}
      image={analyseImage}
      bulletsTitle={intro.servicesLabel}
      bullets={intro.servicesList}
    />
  )
}

export default AnalyseContent
